/**
 * Auth Background — a calm, static wash behind the sign-in pages: a soft
 * diagonal gradient from the brand accent through the page background.
 * Theme-driven (token classes only), no motion.
 */

import { FC } from 'react';

export const AuthBackgroundEffects: FC = () => (
  <div className="pointer-events-none fixed inset-0 -z-0 bg-gradient-to-br from-primary/10 via-background to-warning/10" aria-hidden />
);

export default AuthBackgroundEffects;
